import { useQuery } from '@tanstack/react-query';
import { contactApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Contacts for one customer number; refreshed by every contact write. */
export function useContactsByCustomer(
  customerNumber: string | null | undefined,
) {
  const trimmed = customerNumber?.trim() ?? '';
  return useQuery({
    queryKey: queryKeys.organization.contactsByCustomer(trimmed),
    queryFn: ({ signal }) =>
      contactApiClient.list({ customerNumber: trimmed }, toCancelToken(signal)),
    enabled: trimmed !== '',
    staleTime: 60_000,
    meta: { errorContext: 'customer contacts' },
  });
}
